module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/productos/modificacion-precio/precio-modificacion/precio-modificacion.component.html
// module id = ./src/app/productos/modificacion-precio/precio-modificacion/precio-modificacion.component.html
// module chunks = main